import { getLocale } from "../runtime";

const sv_changemarket = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Välj land`
};

const changemarket = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_changemarket(inputs)
	return "changeMarket";
};

export { changemarket as "changeMarket" };